var _path, _path2, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashDuotone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.666 49.9993C26.666 48.428 26.666 47.6423 27.1542 47.1542C27.6423 46.666 28.428 46.666 29.9993 46.666H129.999C131.571 46.666 132.356 46.666 132.845 47.1542C133.333 47.6423 133.333 48.428 133.333 49.9993V51.6763C133.333 52.2826 133.333 52.5858 133.239 52.8531C133.159 53.0815 133.03 53.2899 132.862 53.4635C132.665 53.6667 132.394 53.8023 131.851 54.0734C127.513 56.2426 125.344 57.3272 123.766 58.9526C122.417 60.342 121.387 62.0085 120.747 63.8363C119.999 65.9745 119.999 68.3997 119.999 73.2501V106.666C119.999 119.237 119.999 125.522 116.094 129.427C112.189 133.333 105.903 133.333 93.3327 133.333H66.666C54.0952 133.333 47.8098 133.333 43.9046 129.427C39.9993 125.522 39.9993 119.237 39.9993 106.666V73.2501C39.9993 68.3997 39.9993 65.9745 39.2512 63.8363C38.6117 62.0085 37.5817 60.342 36.2329 58.9526C34.655 57.3272 32.4858 56.2426 28.1475 54.0734C27.6052 53.8023 27.3341 53.6667 27.1368 53.4635C26.9682 53.2899 26.8395 53.0815 26.7595 52.8531C26.666 52.5858 26.666 52.2826 26.666 51.6763V49.9993Z",
    fill: "#FF0050"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1216 29.1366C67.8813 28.4278 69.5552 27.8015 71.8838 27.3548C74.2124 26.9081 77.0655 26.666 80.0006 26.666C82.9358 26.666 85.7889 26.9081 88.1175 27.3548C90.4461 27.8015 92.12 28.4278 92.8797 29.1366",
    stroke: "black",
    strokeWidth: 6.66667,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 93.334,
    y: 73.334,
    width: 6.66667,
    height: 40,
    rx: 3.33333,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 73.334,
    width: 6.66667,
    height: 40,
    rx: 3.33333,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashDuotone);
export default __webpack_public_path__ + "static/media/Trash_duotone.bb507ff5b97616bb19521a6eb1b38bdd.svg";
export { ForwardRef as ReactComponent };